import type { ReactNode } from 'react';
import { LoadingSpinner } from '@/shared/components/ui/loadingspinner';
import { useQuote } from '../context/QuoteContext';
import { QuoteLoadFailure } from './QuoteLoadFailure';
import { ReloadQuoteModal } from './ReloadQuoteModal';

interface QuoteDraftGateProps {
    children: ReactNode;
}

const spinner = (message: string) => (
    <LoadingSpinner message={message} className="min-h-screen p-4" size="xl" />
);

export const QuoteDraftGate: React.FC<QuoteDraftGateProps> = ({ children }) => {
    const { reload } = useQuote();
    const { phase, wizardShown, conflictStatus, confirmReload, retryMountLoad } = reload;
    if (phase === 'mount-failed') return <QuoteLoadFailure onRetry={retryMountLoad} />;
    if (phase === 'mount-loading') return spinner('Loading Quote...');
    if (phase === 'reloading') return spinner('Reloading quote...');

    const modalOpen = phase === 'conflict' || phase === 'reload-failed';
    return (
        <>
            {phase === 'ready' || wizardShown ? children : spinner('Loading Quote...')}
            <ReloadQuoteModal
                isOpen={modalOpen}
                quoteStatus={conflictStatus}
                failed={phase === 'reload-failed'}
                onReload={confirmReload}
            />
        </>
    );
};
